<template>
  <div class="socialpost" id="tinyScreenSocialpost">
    <Header></Header>
    <!-- banner -->
    <div class="bannerBox">
      <div class="container">
        <div class="storyTxt">
          <div v-if="lang == 'en'">
            <h5>{{bannerBox.enSubContent}}</h5>
            <span>{{bannerBox.enContent}}</span>
          </div>
          <div v-else>
            <h5>{{bannerBox.cnSubContent}}</h5>
            <span>{{bannerBox.cnContent}}</span>
          </div>
        </div>
        <img class="fr mt30" width="300px" :src="bannerBox.pcAdvertUrl">
      </div>
    </div>
    <!-- section1 -->
    <div class="section1">
      <div class="container">
        <h4 class="title titleTxt">{{$t('socialPost.banner')}}</h4>
        <p class="subTitle">{{$t('socialPost.look')}}</p>
        <el-tabs class="pcShow" tab-position="left" style="height: 200px;" v-model="activeName" @tab-click="tagName">
          <el-tab-pane v-for="(item,index) in postList" :key="index" :id="item.id" :name="lang=='en'?item.typeEnName:item.typeName" :label="lang=='en'?item.typeEnName:item.typeName">
            <ul class="containBox">
              <li :class="{'active':n==liIndex}" @click="goDetail(e.id)" @mouseover="liIndex = n" @mouseout="liIndex = -1" v-for="(e,n) in jobSubList" :key="n">
                <div class="box">
                  <div>
                    <span class="title">{{e.title}}</span>
                    <!-- <span class="type">({{e.type}})</span> -->
                  </div>
                  <div class="place">{{e.location}}</div>
                </div>
              </li>
            </ul>
            <div class="pagination">
              <el-pagination class="pagination" @current-change="handleChangePage" :total="dataTotal"
          @size-change="handleSizeChange" :current-page.sync="fromData.pageNum"
            layout="prev, pager, next" :page-size="fromData.pageSize">
              </el-pagination>
            </div>   
          </el-tab-pane>
        </el-tabs>
        <div class="phoneShow  middle">
          <div class="listHeader">
            <el-select v-model="id" @change="changeId(id)" :placeholder="$t('socialPost.placeholder')">
              <el-option
                v-for="item in postList"
                :key="item.id"
                :label="lang=='en'?item.typeEnName:item.typeName"
                :value="item.id">
              </el-option>
            </el-select>
            <!-- <span class="activeName">{{activeName}}</span> -->
          </div>
          <ul class="phoneShow">
             <li @click="goDetail(e.id)"  v-for="(e,n) in jobSubList" :key="n">
                <div class="box">
                  <span class="phoneTitle">{{e.title}}</span>
                    <!-- <span class="type">({{e.type}})</span> -->
                  <div class="phonePlace">{{e.location}}</div>
                </div>
              </li>
          </ul>
          <div class="pagination">
              <el-pagination class="pagination" @current-change="handleChangePage" :total="dataTotal"
          @size-change="handleSizeChange" :current-page.sync="fromData.pageNum"
            layout="prev, pager, next" :page-size="fromData.pageSize">
              </el-pagination>
            </div> 
        </div>
      </div>
    </div>
    <!-- section2 -->
    <Code></Code>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
import Code from '../common/code';
export default {
  data() {
    return {
      type:'',
      activeName:'',
      dataTotal:0,
      index:0,
      id:0,
      liIndex:-1,
      isShowSearch:false,
      fromData:{
        typeId :'',
        pageSize:10,
        pageNum:1
      },
      subTagId:'',
      jobSubList:[],
      postList:[],
      lang:'',
      bannerBox:{
        pcAdvertUrl:'',
        mobileAdvertUrl:'',
        cnContent:'',
        cnSubContent:'',
        enContent: '',
        enSubContent: '',
      }      
    };
  },
  components: { Header,Footer,Code },
  created(){
    this.getAllJobType();
    this.lang = window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'cn';
  },
  mounted(){
    this.activeName = this.$route.query.title?this.$route.query.title:'';
    this.type =this.$route.query.type?this.$route.query.type:'';
    this.id = this.$route.query.id?this.$route.query.id:'';    
    this.getAdvert();
  },
  methods: {
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
    goDetail(id){
      this.$router.push({  
            path: '/socialDetail',
            query:{id:id}
        }) 
    },
    getTag(){
      let dot = document.getElementsByClassName("el-tabs__active-bar");
      let index = Number(this.index)+1;
      dot[0].style.marginTop = Number(20*index-10)+'px';
      dot[0].style.transform = 'translateY('+Number(40*index-40)+'px)';
    },
    tagName(targetName){
      let dot = document.getElementsByClassName("el-tabs__active-bar");
      let n = targetName.index;
      this.getJobByPage(targetName.$attrs.id);
      let index = Number(n)+1;
      dot[0].style.marginTop = Number(20*index-10)+'px';
    },
      // 获取所有岗位分类
    async getAllJobType() {
        const { data: res } = await this.$http.get("/job/getAllJobType.do");
        if (res.code !== 200) return this.$message.error(res.message);
        this.postList = res.data;    
        if(this.type != 'init'){
            if(this.lang == 'en'){
              this.activeName = this.postList[0].typeEnName;
            }else{
              this.activeName = this.postList[0].typeName;
            } 
          this.id = this.postList[0].id;
          this.getJobByPage(this.id);
        }else{
          this.postList.forEach((e,n)=>{
            if(e.id ===  this.id){
              this.index = n;
            }
          })
          this.getTag();
          this.getJobByPage(this.id);
        }
    },
    changeId(id){
      this.getJobByPage(id);
    },
     // 根据ID获取职位分类
    async getJobByPage(id) {
        const { data: res } = await this.$http.get("/job/getJobByPage.do?typeId="+id+'&pageNum='+this.fromData.pageNum+'&pageSize='+this.fromData.pageSize);
        if (res.code !== 200) return this.$message.error(res.message);
        this.jobSubList = res.data.list;
    },
    handleChangePage(pageNum) {
      this.fromData.pageNum = pageNum;
      this.getJobByPage();
    },
    // 切换单页数量事件
    handleSizeChange(pageSize) {
      this.fromData.pageSize = pageSize;
      this.getJobByPage();
    },
     // 根据埋点ID及非必填项获取广告位
    async getAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=6");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.bannerBox = {
          ...res.data[0]
        };
    },
  }
};
</script>

<style lang="less" scoped>
.socialpost{
  .bannerBox{    
    width: 100%;
    height: 360px;
    background: #333333;
    display: flex;
    .storyTxt{
        display: inline-block;
        padding-top: 112px;
       h5{      
        font-size: 14px;
        /*font-family: PingFangSC-Medium, PingFang SC;*/
        font-weight: 100;
        color: #fff;
        line-height: 22px;
        margin-bottom: 36px;
      }
      span{
        font-size: 40px;
         font-weight: 100;
         color: #fff;
      }
       img{
        margin-top: 170px;
       }
    }
  }
  /*********************************************/
 .section1{
    padding:120px 0 255px 0;
    .title{
      text-align: center;
      font-size: 35px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #900211;
      line-height: 49px;
      letter-spacing: 2px;
    }
    .subTitle{
      margin-top: 10px;
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #353535;
      line-height: 20px;
      text-align: center;
      margin-bottom: 63px;
    }
    /deep/ .el-tabs{
        height: 600px !important;
       }
    /deep/ .el-tabs__header{
      width: 238px;
      margin-top: 30px;
    }
    /deep/ .el-tabs--left .el-tabs__active-bar.is-left, .el-tabs--left .el-tabs__nav-wrap.is-left::after {
        left: 0;
        right: auto;
    }
    /deep/ .el-tabs__item {
      text-align: left;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #9A9A9A;
      line-height: 28px;
      letter-spacing: 1px;
      margin-bottom: 20px;
    }
    /deep/ .is-active{
      color:#353535;
     }
    /deep/ .el-tabs__active-bar{
      height: 8px !important;
      width: 8px;
      background: #900211;
      border-radius: 50px;
      margin-top: 10px;
    }
    /deep/ .el-tabs__nav-wrap::after{
      width: 1px;
      background: #F2F2F2;
    }
      .pagination{
      text-align: center;
      /deep/ .el-pager li.active{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #900211;
      }
      /deep/ .el-pager li{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #9A9A9A;
      }
      /deep/ .btn-next{
        color:#900211 !important;
      }
      /deep/ .btn-next:hover{
        color:#900211;
      }
    }
    .containBox{
      padding: 0 20px 43px 10px;
      height: 520px;
      overflow-y: scroll;
      width: 97%;
    }
    .containBox::-webkit-scrollbar {
        width: 4px;

      }
      .containBox::-webkit-scrollbar-track {
        background-color: #D8D8D8;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius: 2em;
      }
      .containBox::-webkit-scrollbar-thumb {
        background-color: #900211;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius: 2em;
      }
    .containBox{
      height: 560px;
      overflow-y: scroll;
      li.active .box{
        background: #F4F1F2
      }
      li{
        padding-bottom: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #353535;
        line-height: 28px;
        letter-spacing: 1px;
        position: relative;
        border-bottom: 2px solid #F2F2F2;
        cursor: pointer;
        margin:10px 0;
        .box{
          padding:30px 0 30px 16px;
          .title{
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #353535;
            line-height: 28px;
            letter-spacing: 1px;
          }
          .type{
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #353535;
            line-height: 28px;
            letter-spacing: 1px;
          }
          .place{
            text-align: right;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #353535;
            line-height: 22px;
            letter-spacing: 1px;
            position: absolute;
            right: 64px;
            top:37px;
          }
        }
       
      }
    }
 }
 /****************************************************/
  .section2{ 
    height: 430px;
    background: #1C1C1C;
    .section2Box{
       display: flex;
      .destiption{
        height: 88px;
        border-right: 3px solid #CD2A20;
        margin:188px 0 154px 83px;        
        font-size: 26px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 40px;
        padding-right: 40px;
      }
      .destiption:last-of-type{
        padding-right: 0;
        border:none;
        margin-left: 40px;
      }
    }   
 }
}
</style>
